import { ClientPod } from '../generated/graphql';

/**
 * THS contact phone number
 */
export const THS_PHONE_NUMBER = '830-609-8855';

/**
 * Maps client pod to the appropriate contact email address
 */
export function getContactEmailByPod(pod: ClientPod): string {
  switch (pod) {
    case ClientPod.GovernmentSolutions:
      return 'bordermission@teamhousing.com';
    case ClientPod.Energy:
    case ClientPod.Other:
    default:
      return 'reservations@teamhousing.com';
  }
}
